import axios from 'axios'
import * as Store from '@/vuex/store'

const SESSION_ID = typeof crypto.randomUUID === 'function'
  ? crypto.randomUUID()
  : Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)
const FLUSH_INTERVAL_MS = 5000
const MAX_BUFFER_SIZE = 50
const APP_NAME = 'bi-client'

let buffer = []
let flushTimer = null // eslint-disable-line no-unused-vars

const client = axios.create({
  baseURL: process.env.VUE_APP_EXPORTER_API_URL,
  timeout: 10000,
})

function getCompanyId () {
  try {
    return Store.store.getters['companyId']
  } catch {
    return null
  }
}

function getAuthHeader () {
  try {
    const token = Store.store.getters['auth/authToken']
    if (token) {
      return { authorization: 'Bearer ' + token, }
    }
  } catch {
    // Token unavailable — that's fine
  }
  return {}
}

function flush () {
  if (buffer.length === 0) return
  const companyId = getCompanyId()
  if (!companyId) return

  const entries = buffer.splice(0)
  client.post(
    `/company/${companyId}/frontend_logs`,
    {
      app: APP_NAME,
      session_id: SESSION_ID,
      entries,
    },
    { headers: getAuthHeader(), }
  ).catch(() => {
    // Silently drop — never break the app for logging
  })
}

function enqueue (level, message, context) {
  buffer.push({
    level,
    message,
    timestamp: new Date().toISOString(),
    context: context || undefined,
  })
  if (buffer.length >= MAX_BUFFER_SIZE) {
    flush()
  }
}

export const logger = {
  debug (message, context) {
    enqueue('debug', message, context)
  },
  info (message, context) {
    enqueue('info', message, context)
  },
  warn (message, context) {
    enqueue('warn', message, context)
  },
  error (message, context) {
    enqueue('error', message, context)
  },
  flush,
  sessionId: SESSION_ID,
}

export default {
  install (Vue) {
    Vue.prototype.$logger = logger

    flushTimer = window.setInterval(flush, FLUSH_INTERVAL_MS)
    window.addEventListener('beforeunload', flush)

    logger.info('vue2-app-initialized')
  },
}
